import './mobile-nav.scss'
import { EventBus } from 'js/utility/event-bus.js'

export default {
    name: 'mobile-nav',

    data: {
        visibility: 'hidden'
    },

    mounted() {
        this.$el.classList.remove('hidden')
        EventBus.$on('MobileMenu.toggle', () => this.toggle())
    },

    methods: {
        toggle() {
            this.visibility = this.visibility === 'hidden' ? 'visible' : 'hidden'
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/mobile-nav/mobile-nav.js